import React, { FC, ReactNode } from 'react';
import { DiffCheckProductType, ObjectCheckProductType } from 'src/containers/OrdersImportContainer/functions';
import { CustomRenderType, TableColumnType, TableRowType } from 'src/types/table';
import { colors } from 'src/themes/default';
import { getOrderProductDisplayName, getOrderProductDisplaySku } from 'src/utils/orderProductDisplay';
import { formatNumber } from 'src/utils/formatNumber';

import TableSimple from '../TableSimple';

const allColumns: TableColumnType[] = [
    {
        label: 'name',
        key: 'NAME',
    },
    {
        label: 'sku',
        key: 'SKU',
    },
    {
        label: 'count',
        key: 'COUNT',
        type: 'number-filter',
    },
    {
        label: 'avaiable',
        key: 'COUNT_AVAILABLE',
        type: 'number-filter',
    },
    {
        label: 'missingCount',
        key: 'MISSING_COUNT',
        type: 'number-filter',
        customRender: true,
    },
];

export interface NotAllocatedTablePropsType {
    diff: DiffCheckProductType;
    products: ObjectCheckProductType;
    height?: number;
}

const NotAllocatedTable: FC<NotAllocatedTablePropsType> = (props) => {
    const diffIds = Object.keys(props.diff);

    const customRender: CustomRenderType = (column, row): ReactNode | string => {
        switch (column.key) {
            case 'MISSING_COUNT':
                if (row.MISSING_COUNT && row.MISSING_COUNT > 0) {
                    return <span style={{ color: colors.alert_O }}>{formatNumber(row.MISSING_COUNT)}</span>;
                }
                break;
            default:
                break;
        }
        return row[column.key];
    };

    const rows = diffIds.map(
        (id: string): TableRowType => ({
            ...props.products[id],
            MISSING_COUNT: props.diff[Number(id)],
            NAME: getOrderProductDisplayName(props.products[id].product),
            SKU: getOrderProductDisplaySku(props.products[id].product),
        })
    );

    return (
        <div style={{ height: props.height }}>
            <TableSimple
                rowIdKey="PRODUCT_ID"
                rows={rows}
                columsLabelPrefix="ordersImport.notAlocatedtable"
                allColumns={allColumns}
                initSort={{ column: 'NAME', direction: 'DESC' }}
                customRender={customRender}
            />
        </div>
    );
};

export default NotAllocatedTable;
